import React from 'react'
import {AuthContext} from '../../lib/AuthContext';
import ParentComponent from '../../lib/ParentComponent';
import firebase, {auth} from '../../lib/firebase';
import Utils from '../../Utils';
import { NavLink } from 'react-router-dom';
import ar from '../../locale';
import {title,deleteUrl} from '../../constants';
import Loading from '../../lib/Loading';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

export default class Clubs extends ParentComponent {
    
    static contextType = AuthContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            user: context.user,
            clubs: [],
            token: null,
            deleting: {},
            loading: false,
        }
        this.clubRef = firebase.database().ref('clubs/');
    }

    componentDidMount() {
        super.componentDidMount();
        document.title = title + ' - ' +ar.clubs;
        auth.currentUser.getIdToken().then(token => {
            this.state.token = token;
            this.updateState();
        });
        this.clubRef.on('value', response => {
            this.state.clubs = Utils.convertToArrayWithOrderKeyAsc(response.val(),'order');
            this.updateState();
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.clubRef.off('value');
    }

    updateState = () => {
        this.setState(prev => {
            return {...prev}
        })
    };

    showLoading = show => {
        this.state.loading = show;
        this.updateState();
    };

    renderClubs = (club,index) => {
        return(
            <Draggable key={club.key} draggableId={club.key} index={index}>
                {(provided, snapshot) => {
                    const style = {
                        backgroundColor: snapshot.isDragging ? '#ccc' : 'inherit',
                        color: snapshot.isDragging ? 'white' : 'inherit',
                        ...provided.draggableProps.style,
                    };
                    return (
                        <tr 
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={style}>
                            <td>
                                {club.avatar && (
                                    <img src={club.avatar} alt="avatar" className="avatarc" width="30" height="30" />
                                )}
                            </td>
                            <td className="title">
                                <NavLink to={'/clubs/'+club.key}>{club.name}</NavLink>
                            </td>
                            <td>{club.wins || 0}</td>
                            <td>{club.lost || 0}</td>
                            <td>{club.draw || 0}</td>
                            <td>{club.points || 0}</td>
                            <td>
                                {!this.state.deleting[club.key] && (
                                    <i className="fa fa-trash text-danger cursor-pointer" title={ar.delete} onClick={this.deleteConfirmation.bind(this,club)}></i>
                                )}
                                {this.state.deleting[club.key] && (
                                    <div className="d-inline-block spinner-border spinner-border-sm text-danger" role="status"></div>
                                )}
                            </td>
                        </tr>
                    );
                }}
            </Draggable>
        );
    };

    deleteConfirmation = (club) => {
        this.confirm(null,this.deleteClubProcess.bind(this,club));
    };

    deleteClubProcess = (club) => {
        this.state.deleting[club.key] = true;
        this.updateState();
        this.deleteClub(club)
            .then(response => this.deleteClubPlayers(club))
            .then(response => response.json())
            .then(responseJson => {
                this.updateState();
            })
        .catch(error => {
           this.state.deleting[club.key] = false;
           this.showError(error.message); 
        });
    };

    deleteClub = club => {
        return fetch(deleteUrl, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + this.state.token,
                },
                body: JSON.stringify({
                    path: 'clubs/'+club.key,
                }),
            });
    };

    deleteClubPlayers = club => {
        return fetch(deleteUrl, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + this.state.token,
                },
                body: JSON.stringify({
                    path: 'clubs_players/'+club.key,
                }),
            });
    };

    reorderTable = result => {
        if (!result.destination) {
            return;
        }
        const clubs = this.reorder(this.state.clubs, result.source.index,   result.destination.index);
        this.state.clubs = clubs;
        this.updateState();
        this.setState({loading: true});
        let updates = {};
        this.state.clubs.forEach((club,index) => {
            updates[club.key + '/order'] = index;
        });
        this.clubRef.update(updates)
        .then(res => {
            this.showLoading(false);
        }).catch(error => {
            this.showError(error.message);
            this.setState({loading: false});
        });
    };

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    }

    render() {
        return(
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card no-toolbar border-0">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-8 mt-2">
                                        <h2 className="card-title">{ar.clubs}</h2>
                                        <h5 className="card-subtitle">{ar.total} {this.state.clubs.length}</h5>
                                    </div>
                                    <div className="col-sm-4 mt-2 text-md-left">
                                        <NavLink to="/clubs/add" className="btn btn-info btn-rounded">
                                            {ar.add_new}
                                        </NavLink>
                                    </div>
                                </div>
                                <DragDropContext onDragEnd={this.reorderTable}>
                                <table id="sawtable" className="mt-3 tablesaw table-bordered table-striped table-hover table no-wrap"
                                    data-tablesaw-mode="swipe">
                                    <thead>
                                        <tr>
                                            <th scope="col" data-tablesaw-priority="2"
                                                className="border">{ar.logo}
                                            </th>
                                            <th scope="col" data-tablesaw-sortable-col
                                                data-tablesaw-priority="3"
                                                className="border">{ar.title}</th>
                                            <th scope="col" data-tablesaw-priority="2"
                                                className="border">{ar.w}</th>
                                            <th scope="col" data-tablesaw-priority="2"
                                            className="border">{ar.l}</th>
                                            <th scope="col" data-tablesaw-priority="2"
                                            className="border">{ar.d}</th>
                                            <th scope="col" data-tablesaw-priority="2"
                                            className="border">{ar.p}</th>
                                            <th scope="col" className="border">
                                                {ar.delete}
                                            </th>
                                        </tr>
                                    </thead>
                                    <Droppable droppableId="droppable-mine">
                                        {(provided, snapshot) => (
                                            <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                {this.state.clubs.map((club,index) => this.renderClubs(club,index))}
                                                {provided.placeholder}
                                            </tbody>
                                        )}
                                    </Droppable>
                                </table>
                                </DragDropContext>
                            </div>
                        </div>
                    </div>
                </div>
                <Loading show={this.state.loading} />
            </div>
        );
    }
};
